export const ITEMID_QUERY_PARAM = 'ItemID';
export const ISDISCOVERYVIEW_QUERY_PARAM = 'IsDiscoveryView';
export const IMID_QUERY_PARAM = 'InternetMessageID';
export const IMMERSIVEVIEW_QUERY_PARAM = 'Immersive';
export const PRINT_QUERY_PARAM = 'Print';
